// extracted by mini-css-extract-plugin
module.exports = {"colorfullText":"enter_colorfullText__HlgAE","ctn":"enter_ctn__312xf"};